<template>
  <div class="query-section">
    <!-- 第一个查询框 -->
    <div class="query-form">
      <!-- 功能导航栏 -->
      <div class="nav-bar">
        <div
          class="navItem"
          v-for="item in fristSelect"
          :key="item.id"
          @click="selectFunction(item.id)"
          :class="{ choseItem: fristId == item.id }"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 查询信息输入 -->
      <div class="input-area">
        <div class="input-title">
          <div class="q-1">出发地</div>
          <AddressSelect
            clearable
            placeholder="请选择出发地"
            ref="departureArrRef"
            v-model="departureArr"
          ></AddressSelect>
        </div>
        <div class="input-title">
          <div class="q-1">到达地</div>
          <AddressSelect
            clearable
            placeholder="请选择到达地"
            ref="destinationArrRef"
            v-model="destinationArr"
          ></AddressSelect>
        </div>
      </div>
      <!-- 查询按钮 -->
      <div class="button-area">
        <button @click="queryLine">开始查询</button>
      </div>
    </div>

    <!-- 第二个查询框 -->
    <div class="query-form">
      <div class="nav-bar">
        <div
          class="navItem"
          v-for="item in secondSelect"
          :key="item.id"
          @click="selectFunction1(item.id)"
          :class="{ choseItem: secondId == item.id }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="input-secondtitle">
        <text>物流单号</text>
        <textarea placeholder="请输入物流单号" v-model="services"></textarea>
      </div>
      <!-- 查询按钮 -->
      <div class="button-area">
        <button @click="queryTrack">开始查询</button>
      </div>
    </div>
    <!-- 第三个查询框 -->
    <div class="query-form">
      <!-- 功能导航栏 -->
      <div class="nav-bar">
        <view
          class="navItem"
          v-for="item in thireSelect"
          :key="item.id"
          @click="selectFunction2(item.id)"
          :class="{ choseItem: thireId == item.id }"
        >
          {{ item.name }}
        </view>
      </div>
      <!-- 查询信息输入 -->
      <div class="input-area">
        <view class="input-title">
          快递公司
          <input type="text" v-model="expressCompany" />
        </view>
        <view class="input-title">
          快递单号
          <input type="text" v-model="expressNumber" />
        </view>
      </div>
      <!-- 查询按钮 -->
      <div class="button-area">
        <button @click="queryExpress">开始查询</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { ElMessage } from 'element-plus';
  import {
    getQueryProv,
    getQueryCity,
  } from '@/apis/modules/logistics/index.js';
  import AddressSelect from '@/components/AddressSelect';

  export default {
    components: {
      AddressSelect,
    },

    data() {
      return {
        fristSelect: [
          { id: 1, name: '查线路' },
          { id: 2, name: '查运价' },
          { id: 3, name: '查公司' },
          { id: 4, name: '找货源' },
          { id: 5, name: '找车源' },
        ],
        departureArr: [],
        destinationArr: [],
        secondSelect: [
          { id: 1, name: '物流追踪' },
          { id: 2, name: '查快递' },
        ],
        thireSelect: [
          { id: 1, name: '国际快递' },
          { id: 2, name: '国际海运' },
          { id: 3, name: '国际空运' },
        ],
        services: '',
        departure: '',
        destination: '',
        selectedFunction: '',
        expressCompany: '',
        expressNumber: '',
        fristId: 1,
        secondId: 1,
        thireId: 1,
        cascaderOptions: [],
        rawProvinces: [],
      };
    },
    methods: {
      selectFunction(id) {
        // this.selectedFunction = func;
        // // 此处可以添加逻辑来显示相应的查询输入等
        // alert(`选择了: ${func}，请填写出发地和到达地`);
        // console.log(id);
        this.fristId = id;
        // console.log(this.fristId);
      },
      selectFunction1(id) {
        this.secondId = id;
      },
      selectFunction2(id) {
        this.thireId = id;
      },
      // 第一个查询框
      queryLine() {
        const startAddr = this.$refs.departureArrRef.getLabels();
        const endAddr = this.$refs.destinationArrRef.getLabels();
        if (!startAddr || !endAddr) {
          ElMessage({ message: '请填写出发地和到达地', type: 'warning' });
          return;
        }
        this.$router.push({
          path:
            this.fristId === 1
              ? '/domesticLogistics/home'
              : '/freightRateView/index',
          query: { startAddr, endAddr },
        });
      },
      // 第二个查询框
      queryTrack() {
        const orderNo = this.services.split(/[\s,，]+/).filter(Boolean)[0];
        if (orderNo) {
          this.$router.push({ path: '/trackView/index', query: { orderNo } });
        } else {
          alert('请输入物流单号');
        }
      },
      // 第三个查询框
      queryExpress() {
        if (this.expressCompany && this.expressNumber) {
          alert(
            `查询功能正在完善，快递公司: ${this.expressCompany}, 快递单号: ${this.expressNumber}`,
          );
        } else {
          alert('请填写快递公司和快递单号');
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .query-section {
    width: 1400px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* gap: 24px; */
    margin-top: -36px;
    margin-bottom: 24px;
    z-index: 99;
  }

  .query-form {
    width: 450px;
    height: 320px;
    background: white;
    /* border-radius: .5rem; */
    box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-right: 24px;
  }

  .nav-bar {
    display: flex;
    align-items: center;
    padding: 24px 0 0 0;
    border-bottom: 1px solid #ddd;
    margin: 0 18px;

    .navItem {
      box-sizing: border-box;
      margin-right: 24px;
      padding-bottom: 16px;
      color: rgba(0, 27, 81, 0.4);
      border-bottom: 4px solid rgba(0, 0, 0, 0);
      cursor: pointer;
      //字体
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: normal;
    }

    .choseItem {
      border-bottom: 4px solid #001b51;
      margin-right: 24px;
      color: #001b51;
    }
  }

  .input-area {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 17px;
    padding-right: 17px;
    margin-top: 24px;

    .input-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #001b51;
      margin-bottom: 16px;
      height: 56px;

      .q-1 {
        width: 3em;
        white-space: nowrap;
        margin-right: 12px;
      }

      input {
        padding-left: 16px;
      }
    }
  }

  .input-area input {
    width: 338px;
    height: 56px;
    border-radius: 4px;
    background: #f2f2f2;
    border: none;
    box-sizing: border-box;
    margin-left: 8px;
    outline: none;
  }

  .button-area {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-area button {
    padding: 0.625rem 1.25rem;
    background: #ffba2f;
    color: #001b51;
    font-size: 18px;
    font-weight: 500;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;
    height: 64px;
    width: 100%;
    margin: 0 20px;
  }

  .input-secondtitle {
    color: #001b51;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    margin-left: 17px;
    margin-top: 24px;
    margin-bottom: 16px;
  }

  .input-secondtitle textarea {
    width: 322px;
    height: 128px;
    padding: 16px 16px 0px 16px;
    box-sizing: border-box;
    border: none;
    outline: none;
    background: #f2f2f2;
    margin-left: 12px;
    resize: none;
    /* 禁止用户手动调整大小 */
    // 字体
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: normal;
  }

  .input-secondtitle textarea::placeholder {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: normal;
    color: rgba(0, 27, 81, 0.3);
  }

  .input-secondtitle text {
    margin-top: 12px;
  }
</style>
